import React from 'react';
import { IntlProvider } from 'react-intl';
import translations from './translations.json';
import { getLanguageFromPath } from './urlHelper.js';

export default class IntlProviderConfigured extends React.Component {
    constructor(props) {
        super(props);
        let initialLocale = props.locale || '';
        if (!initialLocale && typeof window !== 'undefined') {
            const detected = getLanguageFromPath(window.location.pathname);
            initialLocale = detected.code;
        }

        this.state = {
            loading: false,
            locale: initialLocale
        };
    }

    static localeSelected = undefined;
    static urlLang = 'en';

    componentDidMount() {
        const detected = getLanguageFromPath(window.location.pathname);
        if (this.state.locale !== detected.code) {
            this.setState({ locale: detected.code });
        }
    }

    static preInitStore(url) {
        return new Promise((resolve) => {
            const detected = getLanguageFromPath(url);
            IntlProviderConfigured.localeSelected = detected.code;
            IntlProviderConfigured.urlLang = detected.lang;
            resolve(true);
        });
    }

    render() {
        const locale = this.props.locale || this.state.locale || IntlProviderConfigured.localeSelected || 'en-US';
        const messages = translations[locale] || translations['en-US'];
        const { children } = this.props;

        return (
            <IntlProvider locale={locale} messages={messages}>
                {children}
            </IntlProvider>
        );
    }
}